import { render, staticRenderFns } from "./PhoneFile.vue?vue&type=template&id=07c5658e&"
import script from "./PhoneFile.vue?vue&type=script&lang=js&"
export * from "./PhoneFile.vue?vue&type=script&lang=js&"
import style0 from "./PhoneFile.vue?vue&type=style&index=0&id=07c5658e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports